import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SaleItemCompanyBranchService = {
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
};

export { SaleItemCompanyBranchService };
